export default __webpack_public_path__ + "static/media/logoblanco.2c438073.png";